import { Component, OnInit, ViewChild, ViewEncapsulation, Input, OnDestroy, ElementRef } from '@angular/core';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';

import { NgxPermissionsService, NgxRolesService } from 'ngx-permissions';
import { DragulaService } from 'ng2-dragula';
import { formatDate } from '@angular/common';
import { Subscription } from 'rxjs';

//import constants
import { AppSettings } from '../../../../../constants/app-settings';
import { AppFrontRoutes } from '../../../../../constants/app-front-routes';

//import services
import { ServicingService } from '../../../../../services/servicing.service';
import { MeasurementService } from '../../../../../services/measurement.service';
import { ConfirmationDialogService } from '../../../../general/modals/confirmation/confirmation.service';
import { GeneralService } from '../../../../../services/general.service';

//import components
import { MeasurementExtraOrdinaryComponent } from '../../measurement-list/measurement-extraordinary/measurement-extraordinary.component';

declare var $: any;

@Component({
  selector: 'app-measurement-view',
  templateUrl: './measurement-view.component.html',
  styleUrls: ['./measurement-view.component.css']
})

export class MeasurementViewComponent implements OnDestroy, OnInit {

  public barChartOptions = {
    scaleShowVerticalLines: false,
    responsive: true,
  };
  public barChartLabels = [];
  public barChartType = '';
  public barChartLegend = true;
  public barChartData = [];

  getPhotoBase64;

  dropdownList = [];
  dropdownList1 = [];
  dropdownList2 = [];
  dropdownList3 = [];
  selectedItems = [];
  dropdownSettings = {};
  dropdownSettings1 = {};
  dropdownSettings2 = {};
  dropdownSettings3 = {};
  //dropdownSettings:IDropdownSettings;

  //common data
  data: any;

  readonly AppSettings = AppSettings;
  readonly AppFrontRoutes = AppFrontRoutes;

  datatableOptions1: any;
  datatableOptns: any;
  datatableOptions2: any;
  datatableOptions3: any;
  datatableOptions4: any;
  datatableTrigger1: Subject<any> = new Subject();
  datatableColsDefs1: any;
  datatableColsDefs2: any;
  datatableColsDefs3: any;
  datatableColsDefs4: any;
  datatableCols1: any;
  datatableCols2: any;
  datatableCols3: any;
  datatableCols4: any;
  datatableAddCols1: any;

  @Input() filter1: string;
  @Input() filter2: string;
  @Input() filter3: string;
  @Input() filter4: string;
  @ViewChild(DataTableDirective) datatableElement: DataTableDirective;

  addServicingModal: BsModalRef;
  viewServicingModal: BsModalRef;
  addExtraModel: BsModalRef;
  addMaintenanceModel: BsModalRef;
  deleteOption: any;
  extraordinayModal: BsModalRef;
  ordinayModal: BsModalRef;
  ordinary_data: BsModalRef;


  chartType: string = 'line';
  chartData: any[];
  chartLabels: any[];
  chartColors: any[];
  chartOptions: any;


  lang: any;
  odlang: any;
  exodlang: any;
  generalData: any;
  mLang: any;
  maintenanceData: any;
  records: any;
  single_data: any;
  plans: any;
  imgQR: any;
  exordinary_data: any;
  documents_data: any;
  planvals: any;
  cnt: any;
  doclang: any;
  year: any;
  dataSource: Object;
  chartConfig: Object;
  year1: any;
  merge_val: any;
  ord_data: any;
  extra_ord_data: any;
  or_cst: any;
  exor_cst: any;
  baryrs: any;
  
  dataSource1: Object;
  chartConfig1: Object;
  subs = new Subscription();

  pageView: string = 'list';
  timezone = localStorage.getItem('timezone');

  id: number;


  generalsForm: FormGroup;
  generalsFormSubmitted: Boolean = false;
  generalsFormMsg: any;
  rolepermission: any;


  constructor(
    private formBuilder: FormBuilder,

    private servicingService: ServicingService,
    private measurementService: MeasurementService,
    private modalService: BsModalService,
    private confirmationDialogService: ConfirmationDialogService,
    private route: ActivatedRoute,
    private router: Router,
    private generalService: GeneralService,
    private ngxRolesService: NgxRolesService,
    private dragulaService: DragulaService,

  ) {


    this.chartConfig = {
      width: '500',
      height: '400',
      type: 'column2d',
      dataFormat: 'json',
    };
    
    this.chartConfig1 = {
      width: '500',
      height: '400',
      type: 'column2d',
      dataFormat: 'json',
    };
    
   }


  ngOnInit() {
    //fetch data

    this.data = this.route.snapshot.data['sdata'];
    // console.log(this.data);  

    var role = this.ngxRolesService.getRole('servicing');
    
    this.rolepermission = '';
    if (role) {
      this.rolepermission = role.validationFunction[0];
    }


    this.getData();
    //tab2 actions
    this.tab2Actions();
    this.tab3Actions();
    // this.tab4Actions();

    $('#generaltable').dataTable({
      "bPaginate": false,
      "paging": false
    
    });
        
    

    this.subs.add(this.dragulaService.dropModel("exordinary_data")
    .subscribe(({ sourceModel, targetModel, item }) => {
      let arr = []; let table = [];
      // console.log(sourceModel);
      for (let employee of sourceModel) {
        arr.push(employee.extraordinary_serviceId)
      }
      this.updsorting(arr, table);
    })
  );

    
  this.subs.add(this.dragulaService.dropModel("pvdata.ordata")
  .subscribe(({ sourceModel, targetModel, item }) => {
    let arr = []; let table = [];
    // console.log(sourceModel);
    for (let employee of sourceModel) {
      arr.push(employee.ordinaryId)
    }
    this.updsorting1(arr, table);
  })
);

    

  }


  onItemSelect(item: any) {
    console.log(item.item_id);
  }
  onSelectAll(items: any) {
    console.log(items);
  }


  ngOnDestroy(): void {
    $.fn['dataTable'].ext.search.pop();
  }

  pdfDownload(url, name) {

    this.generalService.getAssets(url)
      .subscribe(
        (val) => {

          const url = URL.createObjectURL(val);
          this.downloadUrl(url, name);
          URL.revokeObjectURL(url);


        });

  }

  downloadUrl(url: string, fileName: string) {
    const a: any = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.style = 'display: none';
    a.click();
    a.remove();
  };



  datatableConfg(): void {

    this.datatableOptns = {
      paging: false,
      bAutoWidth: false,
      bSortClasses: false,

    }
  }

  datatableConfig(): void {

    this.datatableColumns();

    this.datatableOptions1 = {
      paging: false,
      bAutoWidth: false,
      bSortClasses: false,
      columnDefs: this.datatableColsDefs1,
      select: {
        style: 'multi',
        selector: 'td:first-child'
      },
      headerCallback: function (thead, data, start, end, display) {

        $('th:first-child input', thead).unbind('click');
        $('th:first-child input', thead).bind('click', () => {

          var table1 = new $.fn.dataTable.Api('#table1');

          var count = table1.rows({ selected: true }).count();
          let selected = true;

          if (count > 0) {
            table1.rows().deselect();
            selected = false;
          }
          else
            table1.rows().select();

          $('th:first-child input', thead).prop("checked", selected);

        });
      },
      initComplete: () => {

        var self = this;
        var table1 = new $.fn.dataTable.Api('#table1');

        table1
          .on('select deselect', function (e, dt, type, indexes) {

            var table1 = new $.fn.dataTable.Api('#table1');
            var selected = table1.rows({ selected: true }).indexes().toArray();

            if (selected.length === 0)
              self.deleteOption = false;
            else
              self.deleteOption = true;
          });

        var buttons1 = new $.fn.dataTable.Buttons(table1, {
          dom: {
            button: {
              className: ''
            }
          },
          buttons: [
            {
              extend: 'csv',
              text: 'Export CSV',
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table1');
                  var selected = dt.rows({ selected: true }).indexes().toArray();
                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'pdfHtml5',
              text: 'Export PDF',
              className: 'btn btn-info',
              orientation: 'landscape',
              pageSize: 'A3',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table1');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;


                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'excel',
              text: 'Export Excel',
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table1');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'print',
              text: 'Print',
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table1');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
          ], select: true
        }).container().appendTo($('#datatableExportBtn1'));

      }
    }


    this.filter1 = '';
    this.filter2 = '';
    this.filter3 = '';
    this.filter4 = '';

  }


  datatableConfig1(): void {

    this.datatableColumns1();

    this.datatableOptions2 = {
      paging: false,
      bAutoWidth: false,
      bSortClasses: false,
      columnDefs: this.datatableColsDefs2,
      select: {
        style: 'multi',
        selector: 'td:first-child'
      },
      headerCallback: function (thead, data, start, end, display) {

        $('th:first-child input', thead).unbind('click');
        $('th:first-child input', thead).bind('click', () => {

          var table2 = new $.fn.dataTable.Api('#table2');

          var count = table2.rows({ selected: true }).count();
          let selected = true;

          if (count > 0) {
            table2.rows().deselect();
            selected = false;
          }
          else
            table2.rows().select();

          $('th:first-child input', thead).prop("checked", selected);

        });
      },
      initComplete: () => {

        var self = this;
        var table2 = new $.fn.dataTable.Api('#table2');

        table2
          .on('select deselect', function (e, dt, type, indexes) {

            var table2 = new $.fn.dataTable.Api('#table2');
            var selected = table2.rows({ selected: true }).indexes().toArray();

            if (selected.length === 0)
              self.deleteOption = false;
            else
              self.deleteOption = true;
          });

        var buttons2 = new $.fn.dataTable.Buttons(table2, {
          dom: {
            button: {
              className: ''
            }
          },
          buttons: [
            {
              extend: 'csv',
              text: this.exodlang.exportCsv,
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table2');
                  var selected = dt.rows({ selected: true }).indexes().toArray();
                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCluod DEMO Service " + formatDate(new Date(), 'yyMMdd', 'en') + '_' + formatDate(new Date(), 'hhmmss', 'en')
            },
            {
              extend: 'pdfHtml5',
              text: this.exodlang.exportPdf,
              className: 'btn btn-info',
              orientation: 'landscape',
              pageSize: 'A3',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table2');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;


                  return false;
                }
              },
              title: "KaizenCluod DEMO Service " + formatDate(new Date(), 'yyMMdd', 'en') + '_' + formatDate(new Date(), 'hhmmss', 'en')
            },
            {
              extend: 'excel',
              text: this.exodlang.exportExcel,
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table2');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCluod DEMO Service " + formatDate(new Date(), 'yyMMdd', 'en') + '_' + formatDate(new Date(), 'hhmmss', 'en')
            },
            {
              extend: 'print',
              text: this.exodlang.exportPrint,
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table2');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCluod DEMO Service " + formatDate(new Date(), 'yyMMdd', 'en') + '_' + formatDate(new Date(), 'hhmmss', 'en')
            },
          ], select: true
        }).container().appendTo($('#datatableExportBtn2'));

      }
    }

    this.filter1 = '';
    this.filter2 = '';
    this.filter3 = '';
    this.filter4 = '';

  }


  datatableConfig2(): void {
    this.datatableColumns2();

    this.datatableOptions3 = {
      paging: false,
      bAutoWidth: false,
      bSortClasses: false,
      columnDefs: this.datatableColsDefs3,
      select: {
        style: 'multi',
        selector: 'td:first-child'
      },
      headerCallback: function (thead, data, start, end, display) {
        $('th:first-child input', thead).unbind('click');
        $('th:first-child input', thead).bind('click', () => {

          let vcnt = $('th:first-child input').val();
          // console.log(vcnt);

          $('.dmulval').val('');

          for (let i = 1; i <= vcnt; i++) {
            if ($('.chk' + i).is(":checked")) {
              var table3 = new $.fn.dataTable.Api('.otable' + i);

              var count = table3.rows({ selected: true }).count();
              let selected = true;

              if (count > 0) {
                table3.rows().deselect();
                selected = false;
              }
              else
                table3.rows().select();

              $('th:first-child input', thead).prop("checked", selected);
              $('.odplus_del' + i).css('display', 'inline-block');
            }
            else {
              var table3 = new $.fn.dataTable.Api('.otable' + i);
              var count = table3.rows({ selected: true }).count();
              let selected = true;

              if (count > 0) {
                table3.rows().deselect();
                selected = false;
              }
              $('.odplus_del' + i).css('display', 'none');
            }
          }

          // var table3 = new $.fn.dataTable.Api('.otable1');

          // var count = table3.rows({ selected: true }).count();
          // let selected = true;

          // if (count > 0) {
          //   table3.rows().deselect();
          //   selected = false;
          // }
          // else
          //   table3.rows().select();

          // $('th:first-child input', thead).prop("checked", selected);

        });
      },
      // }
    }

  }

  odatatableExport(val) {

    $('.scol_val').val(val);
    $('#odatatableExport3').modal('show');
    // $('#datatableExportBtn3').show();
    $('#datatableExportBtn3').html('');
    let j = val;
    if (j != "") {
      
      var table3 = new $.fn.dataTable.Api('.otable' + j);


      var buttons3 = new $.fn.dataTable.Buttons(table3, {
        dom: {
          button: {
            className: ''
          }
        },
        buttons: [
          {
            extend: 'csv',
            text: 'Export CSV',
            className: 'btn btn-info',
            exportOptions: {
              columns: '.selected',
              rows: function (idx, data, node) {
                var dt = new $.fn.dataTable.Api('.otable' + j);
                var selected = dt.rows({ selected: true }).indexes().toArray();
                if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                  return true;

                return false;
              }
            },
            title: "KaizenCloud"
          },
          {
            extend: 'pdfHtml5',
            text: 'Export PDF',
            className: 'btn btn-info',
            orientation: 'landscape',
            pageSize: 'A3',
            exportOptions: {
              columns: '.selected',
              rows: function (idx, data, node) {
                var dt = new $.fn.dataTable.Api('.otable' + j);
                var selected = dt.rows({ selected: true }).indexes().toArray();

                if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                  return true;


                return false;
              }
            },
            title: "KaizenCloud"
          },
          {
            extend: 'excel',
            text: 'Export Excel',
            className: 'btn btn-info',
            exportOptions: {
              columns: '.selected',
              rows: function (idx, data, node) {
                var dt = new $.fn.dataTable.Api('.otable' + j);
                var selected = dt.rows({ selected: true }).indexes().toArray();

                if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                  return true;

                return false;
              }
            },
            title: "KaizenCloud"
          },
          {
            extend: 'print',
            text: 'Print',
            className: 'btn btn-info',
            exportOptions: {
              columns: '.selected',
              rows: function (idx, data, node) {
                var dt = new $.fn.dataTable.Api('.otable' + j);
                var selected = dt.rows({ selected: true }).indexes().toArray();

                if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                  return true;

                return false;
              }
            },
            title: "KaizenCloud"
          },
        ], select: true
      }).container().appendTo($('#datatableExportBtn3'));
    }

    $('.scol_val').val('');


  }

  close() {
    $('#odatatableExport3').modal('hide');
    // $('#datatableExportBtn3').detach();
    $('#odatatableExport3').clear();
  }

  onchk(i,j)
  {
    // console.log($('#'+i).hasClass('selected'));

    // $('.dmulval').val('');
    if ($('#'+i).hasClass('selected') == false) {
      $('.odplus_del' + j).css('display', 'inline-block');

      // var numbers = new Array(i); 
      // var length = numbers.push();
      // console.log(numbers);
      var dval = $('.dmulval').val();
      if (dval != "")
      {
        var value = parseInt(dval) + j;
      }
      else {
        var value = j;
      }

      // console.log(value);

      $('.dmulval').val(value);
    }
    else
    {
      $('.odplus_del' + j).css('display', 'none');

      var dval = $('.dmulval').val();
      if (dval != "")
      {
        var value1 = parseInt(dval) - j;
      }

      $('.dmulval').val(value1);
    }     
     
  }

  datatableConfig3(): void {

    this.datatableColumns3();

    this.datatableOptions4 = {
      paging: false,
      bAutoWidth: false,
      bSortClasses: false,
      columnDefs: this.datatableColsDefs4,
      select: {
        style: 'multi',
        selector: 'td:first-child'
      },
      headerCallback: function (thead, data, start, end, display) {

        $('th:first-child input', thead).unbind('click');
        $('th:first-child input', thead).bind('click', () => {

          var table4 = new $.fn.dataTable.Api('#table4');

          var count = table4.rows({ selected: true }).count();
          let selected = true;

          if (count > 0) {
            table4.rows().deselect();
            selected = false;
          }
          else
            table4.rows().select();

          $('th:first-child input', thead).prop("checked", selected);

        });
      },
      initComplete: () => {

        var self = this;
        var table4 = new $.fn.dataTable.Api('#table4');
        // console.log(table4);
        table4
          .on('select deselect', function (e, dt, type, indexes) {

            var table4 = new $.fn.dataTable.Api('#table4');
            var selected = table4.rows({ selected: true }).indexes().toArray();

            if (selected.length === 0)
              self.deleteOption = false;
            else
              self.deleteOption = true;
          });

        var buttons3 = new $.fn.dataTable.Buttons(table4, {
          dom: {
            button: {
              className: ''
            }
          },
          buttons: [
            {
              extend: 'csv',
              text: this.doclang.exportCsv,
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table4');
                  var selected = dt.rows({ selected: true }).indexes().toArray();
                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'pdfHtml5',
              text: this.doclang.exportPdf,
              className: 'btn btn-info',
              orientation: 'landscape',
              pageSize: 'A3',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table4');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;


                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'excel',
              text: this.doclang.exportExcel,
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table4');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'print',
              text: this.doclang.exportPrint,
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table4');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
          ], select: true
        }).container().appendTo($('#datatableExportBtn4'));

      }
    }

    this.filter1 = '';
    this.filter2 = '';
    this.filter3 = '';
    this.filter4 = '';

  }

  datatableColumns(): void {

    this.datatableColsDefs1 = [
      {
        targets: 0,
        visible: false,
        orderable: false,
      },
      {
        targets: 1,
        orderable: false,
        className: 'select-checkbox'
      },
    ];

    this.datatableCols1 = [
      { id: 2, value: 'No.', isSelected: false },
      { id: 4, value: 'Description', isSelected: false },
      { id: 5, value: 'Guy', isSelected: false },
      { id: 6, value: 'Badge number', isSelected: false },
      { id: 7, value: 'Factory number', isSelected: false },
      { id: 8, value: 'Brand', isSelected: false },
      { id: 9, value: 'Template', isSelected: false },
      { id: 10, value: 'Date of commissioning', isSelected: false },
      { id: 11, value: 'Place of use', isSelected: false },
      { id: 12, value: 'Resposible', isSelected: false },
      { id: 13, value: 'Attachments', isSelected: false },
      { id: 14, value: 'Maintenance plans', isSelected: false },
      { id: 15, value: 'State of maintenance', isSelected: false },
      { id: 16, value: 'State', isSelected: false },
    ];

    // this.datatableAddCols1 = [
    // { id: 2, value: 'Attachments', isSelected: false },
    // ];

  }

  datatableColumns1(): void {
    this.datatableColsDefs2 = [
      {
        targets: 0,
        visible: false,
        orderable: false,
      },
      {
        targets: 1,
        orderable: false,
        className: 'select-checkbox'
      },
    ];

    this.datatableCols2 = [
      { id: 2, value: this.exodlang.no, isSelected: false },
      { id: 3, value: this.exodlang.dateofIntervention, isSelected: false },
      { id: 4, value: this.exodlang.description, isSelected: false },
      { id: 5, value: this.exodlang.performer, isSelected: false },
      { id: 6, value: this.exodlang.outcome, isSelected: false },
      { id: 7, value: this.exodlang.notes, isSelected: false },
      { id: 8, value: this.exodlang.cost, isSelected: false }
    ];

    // this.datatableAddCols1 = [
    // { id: 2, value: 'Attachments', isSelected: false },
    // ];

  }


  datatableColumns2(): void {
    this.datatableColsDefs3 = [
      {
        targets: 0,
        visible: false,
        orderable: false,
      },
      {
        targets: 1,
        orderable: false,
        className: 'select-checkbox'
      },
    ];

    this.datatableCols3 = [
      { id: 2, value: this.odlang.no, isSelected: false },
      { id: 3, value: this.odlang.executionDate, isSelected: false },
      { id: 4, value: this.odlang.description, isSelected: false },
      { id: 5, value: this.odlang.performer, isSelected: false },
      { id: 6, value: this.odlang.outcome, isSelected: false },
      { id: 7, value: this.odlang.notes, isSelected: false },
      { id: 8, value: this.odlang.option, isSelected: false },
      { id: 9, value: this.odlang.nextintervention, isSelected: false },
      { id: 10, value: this.odlang.referringDate, isSelected: false },
      { id: 11, value: this.odlang.cost, isSelected: false },
      { id: 12, value: this.odlang.attachments, isSelected: false }
    ];

    // this.datatableAddCols1 = [
    // { id: 2, value: 'Attachments', isSelected: false },
    // ];

  }

  // datatableColumns3(): void{
  //   this.datatableColsDefs4 = [
  //   {
  //   targets: 0,
  //   visible: false,
  //   orderable: false,
  //   },
  //   {
  //   targets: 1,
  //   orderable: false,
  //   className: 'select-checkbox'
  //   },
  //   ];

  //   this.datatableCols3 = [
  //   { id: 2, value: 'No.', isSelected: false },
  //   { id: 3, value: 'Execution Date', isSelected: false },
  //   { id: 4, value: 'Description', isSelected: false },
  //   { id: 5, value: 'Performed By', isSelected: false },
  //   { id: 6, value: 'Outcome', isSelected: false },
  //   { id: 7, value: 'Note', isSelected: false },
  //   { id: 8, value: 'Option', isSelected: false },
  //   { id: 9, value: 'Upcoming Maintenance', isSelected: false },
  //   { id: 10, value: 'Reference Date', isSelected: false },
  //   { id: 11, value: 'Cost', isSelected: false },
  //   { id: 12, value: 'Attachments', isSelected: false }
  //   ];

  //   // this.datatableAddCols1 = [
  //   // { id: 2, value: 'Attachments', isSelected: false },
  //   // ];

  // }

  datatableColumns3(): void {
    this.datatableColsDefs4 = [
      {
        targets: 0,
        visible: false,
        orderable: false,
      },
      {
        targets: 1,
        orderable: false,
        className: 'select-checkbox'
      },
    ];

    this.datatableCols4 = [
      { id: 2, value: this.doclang.description, isSelected: false },
      { id: 3, value: this.doclang.date, isSelected: false },
      { id: 4, value: this.doclang.revision, isSelected: false },
      { id: 5, value: this.doclang.attachments, isSelected: false },
      { id: 6, value: this.doclang.status, isSelected: false }
    ];

    // this.datatableAddCols1 = [
    // { id: 2, value: 'Attachments', isSelected: false },
    // ];

  }


  datatableFilter(): void {

    $.fn['dataTable'].ext.search.push((settings, data, dataIndex) => {
      const filt1 = data[4] || '';
      const filt2 = data[10] || '';
      const filt3 = data[11] || '';
      const filt4 = data[14] || '';

      var status = true;

      //if (this.filter1 && filt1 != this.filter1)
      //status = false;

      let a = this.filter1;
      // console.log(a);
      Object.keys(a).forEach(function (key) {
        if (a[key].item_id && filt1 != a[key].item_id)
          status = false;
        return status;
      });



      let aa = this.filter2;
      Object.keys(aa).forEach(function (key) {
        if (aa[key].item_id && filt2 != aa[key].item_id)
          status = false;
        return status;
      });


      let aaa = this.filter3;
      Object.keys(aaa).forEach(function (key) {
        if (aaa[key].item_id && filt3 != aaa[key].item_id)
          status = false;
        return status;
      });


      let aaaa = this.filter4;
      Object.keys(aaaa).forEach(function (key) {
        if (aaaa[key].item_id && filt4 != aaaa[key].item_id)
          status = false;
        return status;
      });


      return status;

    });

  }

  datatableFilterAction(): void {
    // console.log(DataTables.Api);
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {

      dtInstance.draw();

      // dtInstance.columns().every(function () {});


    });
  }

  generalsFormInit(): void {


    this.generalsForm = this.formBuilder.group({
      measurement_doc: ['', [Validators.required]],
      internal_code: ['', [Validators.required]],
      badge_no: ['', [Validators.required]],
      measuring_range: ['', [Validators.required]],
      precision_degree: [''],
      measurement_uncertainty: [''],
      measurement_type: ['', [Validators.required]],
      docval: ['', [Validators.required]],
      measurement_location: ['', [Validators.required]],
      empname: ['', [Validators.required]],
      typecalibration: ['', [Validators.required]],
    });

  }
  FormBuildUpdate(): void {

    this.generalsForm.patchValue({
      measurement_doc: this.single_data.measurement_doc,
      internal_code: this.single_data.internal_code,
      badge_no: this.single_data.badge_no,
      measuring_range: this.single_data.measuring_range,
      precision_degree: this.single_data.precision_degree,
      measurement_uncertainty: this.single_data.measurement_uncertainty,
      measurement_type: this.single_data.measurement_type,
      docval: this.single_data.docval,
      measurement_location: this.single_data.measurement_location,
      empname: this.single_data.empname,
      typecalibration: this.single_data.typecalibration,
    });
  }

  getData() {
    this.route.params.subscribe(params => {
      this.id = params.id;

      this.measurementService.generalList(this.id)
        .subscribe(
          (res) => {
            this.lang = this.measurementService.measurementviewLang(res);
            // console.log(this.lang); teturn false; 
            this.single_data = res.data.single_data;
            this.imgQR = res.data.imgQR;
            this.records = res.data.single_data;
            this.plans = res.data.plans;

            this.generalsFormInit();
            this.FormBuildUpdate();
            //load datatable
            this.datatableConfg();
            this.datatableConfig();
            this.datatableFilter();
          }
        );
    });
  }


  tab2Actions(): void {

    this.route.params.subscribe(params => {
      this.id = params.id;

      this.measurementService.generalList(this.id)
        .subscribe(
          (res) => {
            this.exodlang = this.measurementService.measurementviewLang(res);

            this.exordinary_data = res.data.exordinary_data;

            // this.year = JSON.parse(res.data.year);
            // console.log(this.year);

            // this.dataSource1 = {
            //   "chart": {
            //     "caption": "EXTRAORDINARY MAINTENANCE COSTS",
            //     "theme": "fusion",
            //     "exportEnabled": "1"
            //   },
            //   "data": this.year

            // };

            //load datatable
            this.datatableConfig1();
            // this.datatableFilter();

          }
        );
    });




  }


  tab3Actions(): void {

    this.route.params.subscribe(params => {
      this.id = params.id;

      // console.log(this.data);

      this.measurementService.ordinaryData(this.id)
        .subscribe(
          (res) => {
            this.odlang = this.measurementService.MeasurementOrdinaryLang(res);
            // this.ordinary_data = res.data.planvals.ordata;
            this.planvals = res.data.planvals;

            // this.cnt = this.planvals.length;
            // this.cnt = '10';
            // console.log(cnt);

            this.year = JSON.parse(res.data.year);
            // console.log(res.data.merge_val.length);

            if (res.data.merge_val.length > 0)
            {
               this.merge_val = JSON.parse(res.data.merge_val);
            }
            else {
              this.merge_val = [];
            }

            if (res.data.ordinary_data.length > 0)
            {
               this.ord_data = JSON.parse(res.data.ordinary_data);
            }
            else {
              this.ord_data = [];
            }

            if (res.data.extra_ordinary_data.length > 0)
            {
               this.extra_ord_data = JSON.parse(res.data.extra_ordinary_data);
            }
            else {
              this.extra_ord_data = [];
            }


            if (res.data.or_cst.length > 0)
            {
               this.or_cst = JSON.parse(res.data.or_cst);
            }
            else {
              this.or_cst = [];
            }

            if (res.data.exor_cst.length > 0)
            {
               this.exor_cst = JSON.parse(res.data.exor_cst);
            }
            else {
              this.exor_cst = [];
            }

            if (res.data.baryrs.length > 0)
            {
               this.baryrs = JSON.parse(res.data.baryrs);
            }
            else {
              this.baryrs = [];
            }


            // this.ord_data = JSON.parse(res.data.ordinary_data);
            // this.extra_ord_data = JSON.parse(res.data.extra_ordinary_data);
            // this.or_cst = JSON.parse(res.data.or_cst);
            // this.exor_cst = JSON.parse(res.data.exor_cst);
            // this.baryrs = JSON.parse(res.data.baryrs);

            this.barChartLabels = this.baryrs;
            this.barChartType = 'bar';
            this.barChartLegend = true;
            this.barChartData = [
              { data: this.or_cst, label: 'Ordinary Maintenance Costs' },
               { data: this.exor_cst, label: 'Extra Ordinary Maintenance Costs' }
            ];


            this.chartData = [{
              data: this.ord_data,
              label: 'Ordinary Maintenance Costs',
              fill: false
            }, {
              data: this.extra_ord_data,
              label: 'Extra Ordinary Maintenance Costs',
              fill: false
              }];
            
            this.chartLabels = this.merge_val;
            this.chartColors = [{
              backgroundColor: 'rgba(0, 0, 0, 0.2)',
              borderColor: 'rgba(0, 0, 0, 1)'
            }];
            this.chartOptions = {
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true,
                    stepSize: 1
                  }
                }]
              },
              annotation: {
                drawTime: 'beforeDatasetsDraw',
                annotations: [{
                  type: 'box',
                  id: 'a-box-1',
                  yScaleID: 'y-axis-0',
                  yMin: 0,
                  yMax: 1,
                  backgroundColor: '#4cf03b'
                }, {
                  type: 'box',
                  id: 'a-box-2',
                  yScaleID: 'y-axis-0',
                  yMin: 1,
                  yMax: 2.7,
                  backgroundColor: '#fefe32'
                }, {
                  type: 'box',
                  id: 'a-box-3',
                  yScaleID: 'y-axis-0',
                  yMin: 2.7,
                  yMax: 5,
                  backgroundColor: '#fe3232'
                }]
              }
            }


            //load datatable
            this.datatableConfig2();


          }
        );
    });


  }

  // tab4Actions(): void {

  //   this.route.params.subscribe(params => {
  //     this.id = params.id;

  //     // console.log(params);

  //     this.servicingService.documentsData()
  //       .subscribe(
  //         (res) => {
  //           this.doclang = this.servicingService.ServicingDocumentsLang(res);
  //           this.documents_data = res.data.sdoc_data;
  //           // console.log(this.documents_data);
  //           //load datatable
  //           this.datatableConfig3();
  //           this.datatableFilter();
  //         }
  //       );
  //   });



  // }

  error(msg: any) {
    this.generalService.notify_msg('error', msg);
  }

  redirect() {
    this.router.navigateByUrl('/test', { skipLocationChange: true })
      .then(() => {
        this.router.navigate([AppFrontRoutes.Servicing_List]);
      });
  }

  success(msg: any) {

    //show success message
    this.generalService.notify_msg('success', msg);

    //redirect the current page
    // this.redirect();

    this.router.navigateByUrl('/test', { skipLocationChange: true })
      .then(() => {
        this.router.navigate([AppFrontRoutes.SINGLE_VIEW+'/'+this.id]);
      });
    // setTimeout(() => {
    //   window.location.reload();
    // }, 3000);


  }


  mulitSelect() {
    this.dropdownList = [
      { item_id: this.lang.vehicle, item_text: this.lang.vehicle },
      { item_id: this.lang.plant, item_text: this.lang.plant },
      { item_id: this.lang.machine, item_text: this.lang.machine },
      { item_id: this.lang.fireDispenser, item_text: this.lang.fireDispenser },
      { item_id: this.lang.firstServiceDevice, item_text: this.lang.firstServiceDevice },
      { item_id: this.lang.individualProtectionDevice, item_text: this.lang.individualProtectionDevice },
      { item_id: this.lang.safetyEquipment, item_text: this.lang.safetyEquipment }
    ];


    let that = this;

    let loca = this.lang.locations;
    Object.keys(loca).forEach(function (key) {
      // console.log(loca[key]);   
      that.dropdownList1.push({ item_id: loca[key], item_text: loca[key] },)
    });


    let loca1 = this.lang.responsibles;
    Object.keys(loca1).forEach(function (key) {
      // console.log(loca1[key]);   
      that.dropdownList2.push({ item_id: loca1[key], item_text: loca1[key] },)
    });


    this.dropdownList3 = [
      { item_id: this.lang.active, item_text: this.lang.active },
      { item_id: this.lang.decommissioned, item_text: this.lang.decommissioned },
    ];

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableCheckAll: true,
      itemsShowLimit: 3,
      allowSearchFilter: true
    };

    this.dropdownSettings1 = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false
    };

    this.dropdownSettings2 = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false
    };

    this.dropdownSettings3 = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false
    };


  }


  export1_select_deselect_all(event): void {

    let selected = false;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols1.length; i++) {
      this.datatableCols1[i].isSelected = selected;
    }
    this.datatable_export1_choose_column();

  }

  export1_select_deselect(event): void {

    let selected = false;
    let id = event.target.value;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols1.length; i++) {
      if (this.datatableCols1[i].id == id)
        this.datatableCols1[i].isSelected = selected;
    }

    this.datatable_export1_choose_column();

  }

  datatable_export1_choose_column(): void {

    var table1_name = '#table1';
    var table1 = new $.fn.dataTable.Api(table1_name);

    for (var i = 0; i < this.datatableCols1.length; i++) {
      if (this.datatableCols1[i].isSelected)
        table1.column(parseInt(this.datatableCols1[i].id)).select();
      else
        table1.column(parseInt(this.datatableCols1[i].id)).deselect();
    }

  }



  export2_select_deselect_all(event): void {

    let selected = false;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols2.length; i++) {
      this.datatableCols2[i].isSelected = selected;
    }
    this.datatable_export2_choose_column();

  }

  export2_select_deselect(event): void {

    let selected = false;
    let id = event.target.value;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols2.length; i++) {
      if (this.datatableCols2[i].id == id)
        this.datatableCols2[i].isSelected = selected;
    }

    this.datatable_export2_choose_column();

  }

  datatable_export2_choose_column(): void {

    var table1_name = '#table2';
    var table1 = new $.fn.dataTable.Api(table1_name);

    for (var i = 0; i < this.datatableCols2.length; i++) {
      if (this.datatableCols2[i].isSelected)
        table1.column(parseInt(this.datatableCols2[i].id)).select();
      else
        table1.column(parseInt(this.datatableCols2[i].id)).deselect();
    }

  }


  export3_select_deselect_all(event): void {

    let selected = false;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols3.length; i++) {
      this.datatableCols3[i].isSelected = selected;
    }
    this.datatable_export3_choose_column();

  }

  export3_select_deselect(event): void {

    let selected = false;
    let id = event.target.value;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols3.length; i++) {
      if (this.datatableCols3[i].id == id)
        this.datatableCols3[i].isSelected = selected;
    }

    this.datatable_export3_choose_column();

  }

  datatable_export3_choose_column(): void {

    let vcnt = $('th:first-child input').val();
    // console.log(vcnt);

    for (let j = 1; j <= vcnt; j++) {

      var table1_name = '.otable' + j;
      var table1 = new $.fn.dataTable.Api(table1_name);

      for (var i = 0; i < this.datatableCols3.length; i++) {
        if (this.datatableCols3[i].isSelected)
          table1.column(parseInt(this.datatableCols3[i].id)).select();
        else
          table1.column(parseInt(this.datatableCols3[i].id)).deselect();
      }
    }

  }




  export4_select_deselect_all(event): void {

    let selected = false;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols4.length; i++) {
      this.datatableCols4[i].isSelected = selected;
    }
    this.datatable_export4_choose_column();

  }

  export4_select_deselect(event): void {

    let selected = false;
    let id = event.target.value;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols4.length; i++) {
      if (this.datatableCols4[i].id == id)
        this.datatableCols4[i].isSelected = selected;
    }

    this.datatable_export4_choose_column();

  }

  datatable_export4_choose_column(): void {

    var table1_name = '#table4';
    var table1 = new $.fn.dataTable.Api(table1_name);

    for (var i = 0; i < this.datatableCols4.length; i++) {
      if (this.datatableCols4[i].isSelected)
        table1.column(parseInt(this.datatableCols4[i].id)).select();
      else
        table1.column(parseInt(this.datatableCols4[i].id)).deselect();
    }

  }



  // addServicing() {

  //   this.addServicingModal = this.modalService.show(ServicingCreateComponent, { class: 'modal-lgs', initialState: { 'ID': '', 'langs': this.lang } });
  // }
  setPageView(view) {
    this.pageView = view;
  }

  // addExtra() {

  //   this.addExtraModel = this.modalService.show(ServicingExtraComponent, { class: 'modal-lgs', initialState: { 'ID': '', 'langs': this.lang } });
  // }




  // addMaintenance(SID, SPID, OID) {
  //   this.addMaintenanceModel = this.modalService.show(ServicingMaintenance, { class: 'modal-lgs', initialState: { 'SID': SID, 'SPID': SPID, 'OID': OID, 'action': 'modify', 'langs': this.lang } });
  // }

  // editServicing(ID) {
  //   this.addServicingModal = this.modalService.show(ServicingCreateComponent, { class: 'modal-lgs', initialState: { 'ID': ID, 'langs': this.lang } });
  // }


  // viewServicing() {

  //   this.viewServicingModal = this.modalService.show(ServicingViewserviceComponent, { class: 'modal-lgs', initialState: { 'langs': this.lang } });

  // }



  delete(ID) {

    this.confirmationDialogService.confirm('Servicing Delete Confirmation', 'Are you sure to delete?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.servicingService.delete(ID)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });

        });
  }


  delete_extraordinary(ID) {

    // console.log(ID);

    this.confirmationDialogService.confirm('Delete Confirmation', this.lang.aresuredel)
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.measurementService.delete_extraordinary(ID)
            .subscribe(
              (res) => {
                // return false;
                // if (res.status)
                //   this.success(res.msg);
                // else
                //   this.error(res.msg);


                if (res.status) {
                  this.generalService.notify_msg('success', res.msg);

                  this.router.navigateByUrl('/test', { skipLocationChange: true })
                    .then(() => {
                      this.router.navigate([AppFrontRoutes.SINGLE_VIEW + '/' + this.id]);
                    });
                  localStorage.setItem('selectedVal', 'exord');

                }
                else {
                  this.generalService.notify_msg('error', res.msg);

                  this.router.navigateByUrl('/test', { skipLocationChange: true })
                    .then(() => {
                      this.router.navigate([AppFrontRoutes.SINGLE_VIEW + '/' + this.id]);
                    });
                  localStorage.setItem('selectedVal', 'exord');

                }




              });

        });
  }

  delete_ordinary(ID) {

    this.confirmationDialogService.confirm('Servicing Delete Confirmation', 'Do you want to delete this?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.servicingService.delete_ordinary(ID)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });

        });
  }


  delete_sdocuments(ID) {

    this.confirmationDialogService.confirm('Servicing Documents Delete Confirmation', 'Do you want to delete this?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.servicingService.delete_sdocuments(ID)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });

        });
  }


  turnoff(mID, pid, rid) {

    // console.log(mID);
    // console.log(pid);
    // console.log(rid); return false;

    this.confirmationDialogService.confirm('Deactivate Confirmation', 'Are you sure to deactivate?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.measurementService.turnoff(mID, pid, rid)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });
          $("#sactivate_plan").modal("hide");
        });
  }

  activate_plan(pid, sId) {

    $("#plan_id_forcd").val(pid);
    $("#pservice_id").val(sId);
    $("#sactivate_plan").modal("show");
  }

  multiDelete() {

    var table1 = new $.fn.dataTable.Api('#table1');
    let selectedRows = table1.rows({ selected: true }).ids().toArray();

    // console.log('testtest'); return false;

    this.confirmationDialogService.confirm('User Confirmation', 'Are you sure to delete the selected rows?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.servicingService.multiDelete(selectedRows)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });
        });
  }

  multiDelete1() {
    var table1 = new $.fn.dataTable.Api('#table2');
    let selectedRows = table1.rows({ selected: true }).ids().toArray();

    // console.log(selectedRows); return false;
    this.confirmationDialogService.confirm('Multi Delete Confirmation', 'Are you sure to delete all selected?')
      .subscribe(
        (confirmed) => {
          if (!confirmed)
            return;

          this.measurementService.delete_mextraordinary(selectedRows)
            .subscribe(
              (res) => {
                // if (res.status)
                //   this.success(res.msg);
                // else
                //   this.error(res.msg);
                if (res.status) {
                  this.generalService.notify_msg('success', res.msg);

                  this.router.navigateByUrl('/test', { skipLocationChange: true })
                    .then(() => {
                      this.router.navigate([AppFrontRoutes.SINGLE_VIEW + '/' + this.id]);
                    });
                  localStorage.setItem('selectedVal', 'exord');
                }
                else {
                  this.generalService.notify_msg('error', res.msg);

                  this.router.navigateByUrl('/test', { skipLocationChange: true })
                    .then(() => {
                      this.router.navigate([AppFrontRoutes.SINGLE_VIEW + '/' + this.id]);
                    });
                  localStorage.setItem('selectedVal', 'exord');
                }
              });
        });
  }


  doc_multiDelete() {

    var table4 = new $.fn.dataTable.Api('#table4');
    let selectedRows = table4.rows({ selected: true }).ids().toArray();

    // console.log(selectedRows); return false;

    this.confirmationDialogService.confirm('User Confirmation', 'Are you sure to delete the selected rows?')
      .subscribe(
        (confirmed) => {
          if (!confirmed)
            return;

          this.servicingService.delete_msdocuments(selectedRows)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });
        });
  }


  // deleteMultiOrdinary() {
  //   // console.log('sss1');
  //   var vcnt = $('th:first-child input').val();
  //   var oid = $('#dmulval').val();

  //   if (oid != "") {
  //     // console.log(oid);
  //     this.confirmationDialogService.confirm('User Confirmation', 'Are you sure to delete the selected rows?')
  //       .subscribe(
  //         (confirmed) => {

  //           if (!confirmed)
  //             return;

  //           this.measurementService.deleteMultiOrdinary(oid)
  //             .subscribe(
  //               (res) => {
  //                 if (res.status)
  //                   this.success(res.msg);
  //                 else
  //                   this.error(res.msg);
  //               });
  //         });
      
      
  //   }
  //   else {
  //     for (let i = 1; i <= vcnt; i++) {
  //       // console.log(i);
  //       if ($('.chk' + i).is(":checked")) {
  //         var table3 = new $.fn.dataTable.Api('.otable' + i);
  //         // var table3 = new $.fn.dataTable.Api('.otable3');
  //         let selectedRows = table3.rows({ selected: true }).ids().toArray();

  //         this.confirmationDialogService.confirm('User Confirmation', 'Are you sure to delete the selected rows?')
  //           .subscribe(
  //             (confirmed) => {

  //               if (!confirmed)
  //                 return;

  //               this.measurementService.deleteMultiOrdinary(selectedRows)
  //                 .subscribe(
  //                   (res) => {
  //                     if (res.status)
  //                       this.success(res.msg);
  //                     else
  //                       this.error(res.msg);
  //                   });
  //             });
  //       }
  //     }
  //   }

  // }



  deleteMultiOrdinary() {
    // var vcnt = $('th:first-child input').val();

    let vcnt = $('th:first-child input').val();
    console.log(vcnt);
    var dmval = $('.dmulval').val();

    if (dmval != "") {
      for (let i = 1; i <= dmval; i++) {
        var table3 = new $.fn.dataTable.Api('.otable' + i);
        let selectedRows = table3.rows({ selected: true }).ids().toArray();

        // console.log(selectedRows);
        // return false;

        this.confirmationDialogService.confirm('User Confirmation', 'Are you sure to duplicate the selected rows?')
          .subscribe(
            (confirmed) => {

              if (!confirmed)
                return;

              this.measurementService.deleteMultiOrdinary(selectedRows)
                .subscribe(
                  (res) => {
                    return false;
                    if (res.status)
                      this.success(res.msg);
                    else
                      this.error(res.msg);
                  });
            });
        return false;
      }
    }
    else {
      for (let i = 1; i <= vcnt; i++) {
        var table3 = new $.fn.dataTable.Api('.otable' + i);
        let selectedRows = table3.rows({ selected: true }).ids().toArray();

        // console.log(selectedRows);
        // return false;

        this.confirmationDialogService.confirm('User Confirmation', 'Are you sure to duplicate the selected rows?')
          .subscribe(
            (confirmed) => {

              if (!confirmed)
                return;

              this.measurementService.multiDuplicate(selectedRows)
                .subscribe(
                  (res) => {
                    if (res.status)
                      this.success(res.msg);
                    else
                      this.error(res.msg);
                  });
            });

      }
    }
}



  multiDuplicate() {

    var table2 = new $.fn.dataTable.Api('#table2');
    let selectedRows = table2.rows({ selected: true }).ids().toArray();

    // console.log(selectedRows);

    this.measurementService.multiExtraDuplicate(selectedRows)
      .subscribe(
        (res) => {
          // return false;
          // if (res.status)
          //   this.success(res.msg);
          // else
          //   this.error(res.msg);


          if (res.status) {
            this.generalService.notify_msg('success', res.msg);

            this.router.navigateByUrl('/test', { skipLocationChange: true })
              .then(() => {
                this.router.navigate([AppFrontRoutes.SINGLE_VIEW + '/' + this.id]);
              });
            localStorage.setItem('selectedVal', 'exord');

          }
          else {
            this.generalService.notify_msg('error', res.msg);

            this.router.navigateByUrl('/test', { skipLocationChange: true })
              .then(() => {
                this.router.navigate([AppFrontRoutes.SINGLE_VIEW + '/' + this.id]);
              });
            localStorage.setItem('selectedVal', 'exord');


          }




        });

  }

  multiOrdDuplicate() {

    let vcnt = $('th:first-child input').val();
    for (let i = 1; i <= vcnt; i++) {

      // console.log('.chk' + i);


      // if ($('.chk' + i).is(":checked")) {
        var table3 = new $.fn.dataTable.Api('.otable' + i);
        let selectedRows = table3.rows({ selected: true }).ids().toArray();

        this.measurementService.multiOrdDuplicate(selectedRows)
          .subscribe(
            (res) => {
              if (res.status)
                this.success(res.msg);
              else
                this.error(res.msg);
            });
      // }
    }

  }

  doc_multiDuplicate() {

    var table3 = new $.fn.dataTable.Api('#table4');
    let selectedRows = table3.rows({ selected: true }).ids().toArray();


    this.servicingService.doc_multiDuplicate(selectedRows)
      .subscribe(
        (res) => {
          if (res.status)
            this.success(res.msg);
          else
            this.error(res.msg);
        });

  }

  duplicate(ID) {

    this.confirmationDialogService.confirm('Duplicate Confirmation', 'Are you sure you duplicate this line?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.servicingService.duplicate(ID)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });

        });


  }




  onPhotoPickerChange(ev) {
    let file = ev.target.files[0];
    file = ev.target.files[0];

    // console.log(file.name);
    let file_name = file.name;
    if (!(/\.(csv)$/i).test(file_name)) {
      alert('Please upload valid excel file_name .csv only.');
      $('#file').val('');
    }
    else {
      let fs = new FileReader();
      fs.onload = (res: any) => {
        this.getPhotoBase64 = res.target.result;
        $('#profile_input').val('');
      };
      fs.readAsDataURL(file);
    }
  }

  onclick() {
    let profileImage = this.getPhotoBase64 ? this.getPhotoBase64.split(',').pop() : this.getPhotoBase64;

    if (profileImage != undefined && $('#file').val() != '') {
      this.servicingService.updateImport(profileImage)
        .subscribe(
          (res) => {
            if (res.status) {
              // this.success(res.msg);
              // $("#datatableExport4").modal("hide");
              this.router.navigateByUrl('/test', { skipLocationChange: true })
                .then(() => {
                  this.router.navigate([AppFrontRoutes.Servicing_List]);
                });
              setTimeout(() => {
                window.location.reload();
              }, 3000);

            }
            else {
              // this.error(res.msg);
              // $("#datatableExport4").modal("hide");
              this.router.navigateByUrl('/test', { skipLocationChange: true })
                .then(() => {
                  this.router.navigate([AppFrontRoutes.Servicing_List]);
                });
              setTimeout(() => {
                window.location.reload();
              }, 3000);
            }
          });
    }
  }


  onSubmit(data) {

    // console.log(data.date); return false;

    var plan_id_forcd = $("#plan_id_forcd").val();
    var pservice_id = $("#pservice_id").val();

    if (data.date != "") {
      this.measurementService.active_status(data.date, plan_id_forcd, pservice_id)
        .subscribe(
          (res) => {
            if (res.status) {
              this.success(res.msg);
              $("#sactivate_plan").modal("hide");
            }
            else {
              this.error(res.msg);
              $("#sactivate_plan").modal("hide");

            }
          });
    }
    else {
      alert('Please Enter Start Date!!!');
    }

  }

  add_extraordinary(SID) {
    this.extraordinayModal = this.modalService.show(MeasurementExtraOrdinaryComponent, { class: 'modal-lgs', initialState: { 'SID': SID, 'langs': this.exodlang } });
  }

  edit_extraordinary(ID) {
    this.extraordinayModal = this.modalService.show(MeasurementExtraOrdinaryComponent, { class: 'modal-lgs', initialState: { 'ID': ID, 'langs': this.exodlang } });
  }
  

  // add_ordinary(SID, PID) {
  //   // console.log(PID);
  //   this.ordinayModal = this.modalService.show(ServicingOrdinaryComponent, { class: 'modal-lgs', initialState: { 'SID': SID, 'PID': PID, 'langs': this.odlang } });
  // }

  // edit_ordinary(ID, SID, PID) {
  //   this.ordinayModal = this.modalService.show(ServicingOrdinaryComponent, { class: 'modal-lgs', initialState: { 'ID': ID, 'SID': SID, 'PID': PID, 'langs': this.odlang, 'action': "edit" } });
  // }


  // duplicate_ordinary(ID, SID, PID) {
  //   this.ordinayModal = this.modalService.show(ServicingOrdinaryComponent, { class: 'modal-lgs', initialState: { 'ID': ID, 'SID': SID, 'PID': PID, 'langs': this.odlang, 'action': "duplicate" } });
  // }


  // add_sdocuments(SID) {
  //   console.log(SID);
  //   this.ordinayModal = this.modalService.show(ServicingDocumentsComponent, { class: 'modal-lgs', initialState: { 'SID': SID, 'langs': this.doclang } });
  // }


  // edit_sdocuments(ID, SID) {
  //   this.ordinayModal = this.modalService.show(ServicingDocumentsComponent, { class: 'modal-lgs', initialState: { 'ID': ID, 'SID': SID, 'langs': this.doclang, 'action': 'edit' } });
  // }

  updsorting(data: any, table: any) {
    this.measurementService.sorting2(data, table)
      .subscribe(
        (res) => {
          if (res.status) {
            this.success(res.msg);

          }
          else {
            this.error(res.msg);

          }
        });
  }


  updsorting1(data: any, table: any) {
    this.measurementService.sorting3(data, table)
      .subscribe(
        (res) => {
          if (res.status) {
            this.success(res.msg);

          }
          else {
            this.error(res.msg);

          }
        });
  }



  myClickFunction() {
    // console.log('test');
    var from_date = $("#from_date").val();
    var to_date = $("#to_date").val();

    this.id = this.id;
    // console.log(from_date);
    // console.log(to_date);


    this.measurementService.mstatistics_search(from_date, to_date, this.id)
      .subscribe(
        (res) => {

          this.odlang = this.measurementService.MeasurementOrdinaryLang(res);
          // this.ordinary_data = res.data.planvals.ordata;
          this.planvals = res.data.planvals;

          // this.cnt = this.planvals.length;

          // console.log(this.planvals);
          // console.log(this.cnt);

          // this.year = JSON.parse(res.data.year);
          // this.year1 = JSON.parse(res.data.year1);


          this.merge_val = JSON.parse(res.data.merge_val);
          this.ord_data = JSON.parse(res.data.ordinary_data);
          this.extra_ord_data = JSON.parse(res.data.extra_ordinary_data);

          // console.log(this.merge_val);

          this.chartData = [{  
            data: this.ord_data, 
            label: 'Ordinary Maintenance Costs',
            fill: false
          }, {
            data: this.extra_ord_data,
            label: 'ExtraOrdinary Maintenance Costs',
            fill: false
          }];
          this.chartLabels = this.merge_val;
          this.chartColors = [{
            backgroundColor: 'rgba(0, 0, 0, 0.2)',
            borderColor: 'rgba(0, 0, 0, 1)'
          }];
          this.chartOptions = {
            scales: {
              yAxes: [{
                ticks: {
                  beginAtZero: true,
                  stepSize: 1
                }
              }]
            },
            annotation: {
              drawTime: 'beforeDatasetsDraw',
              annotations: [{
                type: 'box',
                id: 'a-box-1',
                yScaleID: 'y-axis-0',
                yMin: 0,
                yMax: 1,
                backgroundColor: '#4cf03b'
              }, {
                type: 'box',
                id: 'a-box-2',
                yScaleID: 'y-axis-0',
                yMin: 1,
                yMax: 2.7,
                backgroundColor: '#fefe32'
              }, {
                type: 'box',
                id: 'a-box-3',
                yScaleID: 'y-axis-0',
                yMin: 2.7,
                yMax: 5,
                backgroundColor: '#fe3232'
              }]
            }
          }


          // this.dataSource = {
          //   "chart": {
          //     "caption": "Ordinary Maintenance Costs",
          //     "theme": "fusion",
          //     "exportEnabled": "1"
          //   },
          //   "data": this.year

          // };

          // this.dataSource1 = {
          //   "chart": {
          //     "caption": "Extraordinary Maintenance Costs",
          //     "theme": "fusion",
          //     "exportEnabled": "1"
          //   },
          //   "data": this.year1

          // };

          // this.year = res.data.year;
          // this.cost = res.data.cost;

          // this.barChartLabels1 = this.year;
          // this.barChartType1 = 'bar';

          // this.barChartData1 = [
          //   { data: this.cost },
          // ];



          // this.year1 = res.data.year1;
          // this.cost1 = res.data.cost1;

          // this.barChartLabels = this.year1;
          // this.barChartType = 'bar';

          // this.barChartData = [
          //   { data: this.cost1 },
          // ];



          //load datatable
          this.datatableConfig2();

          // if (res.status) {
          //   this.generalService.notify_msg('success', res.msg);

          //   this.router.navigateByUrl('/test', { skipLocationChange: true })
          //     .then(() => {
          //       this.router.navigate([AppFrontRoutes.SERVICING_VIEW + '/' + this.id]);
          //     });

          //   $("#sactivate_plan").modal("hide");
          //   localStorage.setItem('selectedVal', 'general');

          // }
          // else {
          //   this.generalService.notify_msg('error', res.msg);
          //   $("#sactivate_plan").modal("hide");


          //   this.router.navigateByUrl('/test', { skipLocationChange: true })
          //     .then(() => {
          //       this.router.navigate([AppFrontRoutes.SERVICING_VIEW + '/' + this.id]);
          //     });

          //   localStorage.setItem('selectedVal', 'general');

          // }

        });
  }

  convertToPDF(ID:any) {    
    this.measurementService.view_servicing_pdf(ID).subscribe(
        res => {
          var file = new Blob([res], { type: 'application/pdf' });            
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);      
        }
      );
  }  

}
